

<main class="main_acquisition">



  <div class="other_contents">

    <div class="contents">
      <!-- PAYMENTS PAYMENTS=========================PAYMENTS PAYMENTS=================PAYMENTS PAYMENTS===========PAYMENTS PAYMENTS -->
      <div class="payment_module">
        <div class="form_input">



          <!-- PAYMENT DETAILS FORM=========================PAYMENT DETAILS FORM===================== -->

          <div class="cost_Surface--form">
            <h2 class="title">Payment Details</h2>

            <form action="">
              <div class="input">
                <label for="">Claimant/Beneficiary</label>
                <input type="text"
                placeholder="Search Owner"
                aria-label="Number"
                matInput
                class="default_input reference-form"
                [matAutocomplete]="auto" #name (keyup)="searchAddressBook(name.value)" >

                <mat-autocomplete autoActiveFirstOption  #auto="matAutocomplete">
                  <mat-option *ngFor="let addressbook of addressbooks"
                   (click)="selectaddressbook(addressbook)" [value]="addressbook.Name">
                    <span>{{addressbook.Name}}</span>
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="input">
                <label for="">Status</label>
                <mat-select placeholder="filter by payment status"  class="default_input reference-form">
                  <mat-option *ngFor="let status of paymentstatus" [value]="status" (click)="filterByStatus(status)">
                    {{status}}
                  </mat-option>
                  <mat-option value="ALL" (click)="selectAll()">
                    ALL
                  </mat-option>
                </mat-select>
              </div>
            </form>
          </div>

          <!-- Process payment=========================Process payment===================== -->


          <div class="btn_holder">
            <button class="default_primary-button">Submit</button>
          </div>
        </div>
        <!-- right side=========================================right side -->
        <div class="soln">
          <div class="tab_top">
            <div class="summary">
              <p class="total_summary">
                <span>Total:</span>
                <span class="amount" style="color: rgb(199, 38, 38);">{{calcAmount().totalAmt | number:'1.2'}}</span>
              </p>
              <p class="negotiated_summary">
                <span>Negotiated Amt:</span>
                <span class="amount" style="color: rgb(199, 38, 38);">{{calcAmount().totalNeg | number:'1.2'}}</span>
              </p>
              <p class="difference_summary">
                <span>Difference:</span>
                <span class="amount" style="color: rgb(199, 38, 38);">{{(calcAmount().totalAmt - calcAmount().totalNeg) | number:'1.2'}}</span>
              </p>

            </div>


          </div>

          <div class="payment_tab">


            <div class="toggle_payment_view">
              <mat-button-toggle-group
            name="fontStyle"
            aria-label="Font Style"
            color="accent"
            class="m-3"

            >
            <mat-button-toggle value="list" color="accent" (click)="onList()"
              ><mat-icon class="example-tab-icon"
                >list</mat-icon
              ></mat-button-toggle
            >
            <mat-button-toggle value="grid" (click)="onGrid()"
              ><mat-icon class="example-tab-icon"
                >view_module</mat-icon
              ></mat-button-toggle
            >
            </mat-button-toggle-group>
            </div>

            <!-- PAYMENT DETAILS========================PAYMENT DETAILS=====================PAYMENT DETAILS========= -->
            <ng-container *ngIf="gridView">

            <div class="tab_content">
              <div class="pay_content">
                <div class="entry"  *ngFor="let lessor of filteredLessors; index as i">
                  <p class="top_entry--info"><span>{{i + 1}}</span></p>
                  <p class="info"><span>Claimant Type: </span>{{lessor.OwnershipTypeName}}</p>
                  <p class="info"><span>Claimant :</span>{{lessor.ownerName}}</p>
                  <p class="info"><span>Land Type: </span>{{lessor.TerrianName}}</p>
                  <p class="info"><span>Description: </span>{{lessor.ItemName}}</p>
                  <p class="info"><span>Details: </span>{{lessor.ItemName}}</p>
                  <p class="info"><span>Acreages: </span> {{lessor.Area}}</p>
                  <p class="info"><span>Unit Of Measure: </span>{{lessor.MeasureName}}</p>
                  <p class="info"><span>Quantity: </span>{{lessor.Qty}}</p>
                  <p class="info"><span>Rate: </span> {{lessor.Rate}}</p>
                  <p class="info"><span>Actual Amt: </span>{{lessor.Amount | number:'1.2'}}</p>
                  <p class="info"><span>Negotiated Amt: </span>{{lessor.NegotiatedAmount | number:'1.2'}}</p>
                  <p class="info"><span>Approval Remark: </span>{{lessor.ApprovalRemarks}}</p>
                  <button mat-icon-button (click)="deleteLessor(lessor.id)" class="text-danger" [disabled]="lessor.PaymentStatus.includes('PAID')"> <i class="ti-trash"></i></button>


                </div>

              </div>
            </div>

          </ng-container>

          <div class="card mt-3 " *ngIf="listView">
            <div class="table-responsive">
            <table class="table table-hover" >
              <thead>
                <tr>
                  <th scope="col">S/N</th>
                  <th scope="col">Claimant Type</th>
                  <th scope="col">Claimant</th>
                  <th scope="col">Land Type</th>
                  <th scope="col">Description</th>
                  <th scope="col">Details</th>
                  <th scope="col">Acreages</th>
                  <th scope="col">Unit Of Measure</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Rate</th>
                  <th scope="col">Actual Amt</th>
                  <th scope="col">Negotiated Amt</th>
                  <th scope="col">Approval Remark</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody >
                <tr  *ngFor="let lessor of filteredLessors; index as i"
                style="cursor: pointer;"
                >
                  <th scope="row">{{i + 1}}</th>
                  <td>{{lessor.OwnershipTypeName}}</td>
                  <td>{{lessor.ownerName}}</td>
                  <td> {{lessor.TerrianName}}</td>
                  <td>{{lessor.ItemName}}</td>
                  <td>{{lessor.ItemName}}</td>
                  <td>{{lessor.Area}}</td>
                  <td>{{lessor.MeasureName}}</td>
                  <td>{{lessor.Qty}}</td>
                  <td>{{lessor.Rate}}</td>
                  <td>{{lessor.Amount | number:'1.2'}}</td>
                  <td>{{lessor.NegotiatedAmount | number:'1.2'}}</td>
                  <td>{{lessor.ApprovalRemarks}}</td>

                  <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer;">
                    <i class="ti-trash" [hidden]="lessor.PaymentStatus.includes('PAID')" (click)="deleteLessor(lessor.id);"></i>
                   </td>
                </tr>

              </tbody>
            </table>
          </div>
          </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</main>
